import {
    Address,
    AddressValue,
    ContractFunction,
    EndpointDefinition,
    EndpointModifiers,
    EndpointParameterDefinition,
    ProxyProvider,
    SmartContract,
    TypedValue,
    TypeExpressionParser,
    TypeMapper,
    U64Value,
} from '@elrondnetwork/erdjs/out'
import { smartContractAddress, network } from '../config'
import { getWhitelistDataEndpointDef } from './endpointDef'
import BigNumber from 'bignumber.js'
import { fetchQueryResponse } from './scRequests'
import * as config from '../config'

const typeParser = new TypeExpressionParser()
const typeMapper = new TypeMapper()

export const fetchQueryHex = (method, args, scAddress) =>
    new Promise(async (resolve, reject) => {
        let contract = new SmartContract({ address: new Address(scAddress) })
        let provider = new ProxyProvider(network.gatewayAddress || '')
        let response = await contract.runQuery(provider, {
            func: new ContractFunction(method),
            args: args,
        })
        if (response.isSuccess()) {
            if (response.returnData !== undefined) {
                const [encoded] = response.returnData
                if (!encoded) resolve('-1')

                const decoded = Buffer.from(encoded || '', 'base64').toString(
                    'hex'
                )
                resolve(decoded)
            }
        } else {
            reject('Something went wrong')
        }
    })

export const fetchWhitelistData = (address) =>
    new Promise(async (resolve, reject) => {
        let contract = new SmartContract({
            address: new Address(smartContractAddress),
        })
        let provider = new ProxyProvider(network.gatewayAddress || '')
        let response = await contract.runQuery(provider, {
            func: new ContractFunction('getWhitelistInfo'),
            args: [
                new U64Value(new BigNumber(1)),
                new AddressValue(new Address(address)),
            ],
        })
        if (response.isSuccess()) {
            response.setEndpointDefinition(getWhitelistDataEndpointDef())
            let data = response.outputTyped()

            let result = {
                isWhitelisted: data[0].valueOf().field0.valueOf(),
                remainingFreeMints: data[0].valueOf().field1.valueOf(),
                remainingWhitelistBuyingQty: data[0].valueOf().field2.valueOf(),
                price: data[0].valueOf().field3.valueOf().toString(),
                remainingPublicBuyingQty: data[0].valueOf().field4.valueOf(),
            }
            resolve(result)
        } else {
            reject('Something went wrong')
        }
    })

export const getNftStakingData = (userAddress) =>
    Promise.all([
        fetchQueryResponse(
            'user',
            [new AddressValue(new Address(userAddress))],
            config.nftStakingSCAddress
        ),
        // fetchQueryHex("isPublicUseDisabled", [], config.nftStakingSCAddress)
    ]).then(([response]) => {
        let finalObj = undefined
        if (response.isSuccess()) {
            response.setEndpointDefinition(endpointDefinitions.nftStaking())
            let parsed = response.outputTyped()
            finalObj = {
                poolName: 'nftStaking', //config.nftStaking.poolName,
                claimableRewards: parseNumericalValue(
                    parsed[0].fields[0].value.valueOf()
                ),
                rewardsPerDay: parseNumericalValue(
                    parsed[0].fields[1].value.valueOf()
                ),
                stakedNFTs: parseStakedNfts(
                    parsed[0].fields[2].valueOf().value.items
                ),
                isDisabled: '00' === '01',
            }
            console.log(finalObj)
            // console.log("Stake times: ");
            // console.log(finalObj.stakedNFTs.map(s => s.claimMoment + "|||" + s.tokenIdentifier + " " + s.nonce));

            // Promise.resolve(finalObj);
        }
        return finalObj
    })

export const getHeadlockStakingData = (userAddress) =>
    Promise.all([
        fetchQueryResponse(
            'user',
            [new AddressValue(new Address(userAddress))],
            config.headlockSCAddress
        ),
    ]).then(([response]) => {
        let finalObj = undefined
        if (response.isSuccess()) {
            response.setEndpointDefinition(endpointDefinitions.headlock())
            let parsed = response.outputTyped()

            finalObj = {
                poolName: 'headlock',
                amountOfRewards: Number(parsed[0].fields[0].value.valueOf()),
                stakedNFTs: parseHeadlockNFTs(
                    parsed[0].fields[1].valueOf().value.items
                ),
            }
            // console.log("Stake times: ");
            // console.log(finalObj.stakedNFTs.map(s => s.claimMoment + "|||" + s.tokenIdentifier + " " + s.nonce));

            // Promise.resolve(finalObj);
        }
        return finalObj
    })

const endpointDefinitions = {
    nftStaking: () => {
        //TODO: after SFTs are enabled, change mapping to this:
        let types = [
            'tuple3<BigUint, BigUint, List<tuple5<TokenIdentifier, u64, BigUint, BigUint>>>',
        ]
            // let types = ["tuple3<BigUint, BigUint, List<tuple3<TokenIdentifier, u64, BigUint, u64>>>"]
            .map((expression) => typeParser.parse(expression))
            .map((type) => typeMapper.mapType(type))
        let endpointDefinitions = types.map(
            (type) => new EndpointParameterDefinition('foo', 'bar', type)
        )
        let endpointDef = new EndpointDefinition(
            'user',
            [],
            endpointDefinitions,
            new EndpointModifiers('', [])
        )
        return endpointDef
    },
    headlock: () => {
        //TODO: after SFTs are enabled, change mapping to this:
        let types = ['tuple2<u64, List<tuple2<TokenIdentifier, u64>>>']
            // let types = ["tuple3<BigUint, BigUint, List<tuple3<TokenIdentifier, u64, BigUint, u64>>>"]
            .map((expression) => typeParser.parse(expression))
            .map((type) => typeMapper.mapType(type))
        let endpointDefinitions = types.map(
            (type) => new EndpointParameterDefinition('foo', 'bar', type)
        )
        let endpointDef = new EndpointDefinition(
            'user',
            [],
            endpointDefinitions,
            new EndpointModifiers('', [])
        )
        return endpointDef
    },
}

const parseNumericalValue = (val) =>
    val === 0 ? 0 : parseFloat((val / 100_000_000).toFixed(3))

const parseStakedNfts = (val) => {
    if (val.length === 0) {
        return []
    }
    let arr = []
    for (var i = 0; i < val.length; i++) {
        let crt = val[i]

        let nftData = {
            tokenIdentifier: Buffer.from(
                crt.fields[0].value.valueOf()
            ).toString(),
            nonce: parseInt(crt.fields[1].value.valueOf().toString()),
            quantity: parseInt(crt.fields[2].value.valueOf().toString()),
            dailyReward:
                parseInt(crt.fields[3].value.valueOf().toString()) /
                100_000_000,
        }
        arr.push(nftData)
    }
    return arr
}

const parseHeadlockNFTs = (val) => {
    if (val.length === 0) {
        return []
    }
    let arr = []
    for (var i = 0; i < val.length; i++) {
        let crt = val[i]

        let nftData = {
            tokenIdentifier: Buffer.from(
                crt.fields[0].value.valueOf()
            ).toString(),
            nonce: parseInt(crt.fields[1].value.valueOf().toString()),
        }
        arr.push(nftData)
    }
    return arr
}
